import Swal from 'sweetalert2';

const TrackingModal = ({ data, closeModal }) => {
  console.log('Modal Data:', data);
  console.log('Close Modal Function:', closeModal);

  if (!data) {
    Swal.fire({
      icon: 'error',
      title: 'Tracking Details',
      text: 'Tracking number not found.',
    });
    closeModal();
    return null;
  }

  const lastUpdateDate = data.last_update.toDate();
  const date = data.date.toDate();

  Swal.fire({
    icon: 'info',
    html: `
      <h4 class="text-xl mb-4">Tracking Details</h4>
      <table class="table">
        <tbody>
          <tr>
            <td>Tracking ID:</td>
            <td>${data.tracking_id}</td>
          </tr>
          <tr>
            <td>User Name:</td>
            <td>${data.user_name}</td>
          </tr>
          <tr>
            <td>From Country:</td>
            <td>${data.from_country}</td>
          </tr>
          <tr>
            <td>To Country:</td>
            <td>${data.to_country}</td>
          </tr>
          <tr>
            <td>Last Update:</td>
            <td>${lastUpdateDate.toLocaleDateString()}</td>
          </tr>
          <tr>
            <td>Status:</td>
            <td>${data.status}</td>
          </tr>
        </tbody>
      </table>`,
    showConfirmButton: false,
    timer: 10000,
  }).then(() => closeModal());

  return null;
};

export default TrackingModal;
